import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/codiepie': {
    width: 472,
    height: 512,
    paths: [
      {
        d: 'M422.5 202.9c30.7 0 33.5 53.1-0.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6c-42.1 91.9-121.6 151.4-224 151.4-137 0-248-111-248-248s111-248 248-248c97.4 0 172.8 53.7 218.2 138.4l-186 108.8zM433.5 365.1l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5s98.3 219.5 219.5 219.5c78.6 0 146.5-42.1 185.5-110.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/codiepie.js
// module id = 761
// module chunks = 0